window.WhovixProduct = (function () {
  function init(sectionId) {
    var data = window['__whovixProduct_' + sectionId.replace(/-/g, '_')];
    if (!data) return;

    var root = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!root) return;

    var variants = data.variants;
    var optionButtons = root.querySelectorAll('.whovix-option');
    var selected = [];

    // seed selected[] from currently active pills
    optionButtons.forEach(function (optEl, idx) {
      var active = optEl.querySelector('.whovix-option__pill.is-active');
      selected[idx] = active ? active.getAttribute('data-option-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].slice(0, data.optionsCount);
        return opts.every(function (o, i) { return o === selected[i]; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2) + ' ' + (window.Shopify && Shopify.currency ? Shopify.currency.active : '');
    }

    function updateUI(variant) {
      var priceEl = document.getElementById('WhovixPrice-' + sectionId);
      var idInput = document.getElementById('WhovixVariantId-' + sectionId);
      var addBtn = document.getElementById('WhovixAddToCart-' + sectionId);
      var buyBtn = document.getElementById('WhovixBuyNow-' + sectionId);
      var atcText = addBtn ? addBtn.querySelector('[data-whovix-atc-text]') : null;

      if (!variant) {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (buyBtn) buyBtn.setAttribute('disabled', 'disabled');
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;

      var currentEl = priceEl.querySelector('.whovix-product__price-current');
      var compareEl = priceEl.querySelector('.whovix-product__price-compare');
      var badgeEl = priceEl.querySelector('.whovix-product__badge-sale');

      currentEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'whovix-product__price-compare';
          priceEl.appendChild(compareEl);
        }
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        if (!badgeEl) {
          badgeEl = document.createElement('span');
          badgeEl.className = 'whovix-product__badge-sale';
          badgeEl.textContent = 'Sale';
          priceEl.appendChild(badgeEl);
        }
        badgeEl.style.display = '';
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }

      if (variant.available) {
        addBtn.removeAttribute('disabled');
        if (buyBtn) buyBtn.removeAttribute('disabled');
        if (atcText) atcText.textContent = 'Add to cart';
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        if (buyBtn) buyBtn.setAttribute('disabled', 'disabled');
        if (atcText) atcText.textContent = 'Sold out';
      }

      if (variant.featured_media) {
        var img = document.getElementById('WhovixActiveImage-' + sectionId);
        var thumb = root.querySelector('.whovix-product__thumb[data-full*="' + variant.featured_media.id + '"]');
        if (img && variant.featured_image) {
          img.src = variant.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '$1');
        }
      }
    }

    optionButtons.forEach(function (optEl) {
      var pos = parseInt(optEl.getAttribute('data-option-position'), 10) - 1;
      optEl.querySelectorAll('.whovix-option__pill').forEach(function (btn) {
        btn.addEventListener('click', function () {
          optEl.querySelectorAll('.whovix-option__pill').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selected[pos] = btn.getAttribute('data-option-value');
          updateUI(findVariant());
        });
      });
    });

    // Thumbnails
    root.querySelectorAll('[data-whovix-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-whovix-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var img = document.getElementById('WhovixActiveImage-' + sectionId);
        if (img) img.src = thumb.getAttribute('data-full');
      });
    });

    // Quantity
    var qtyInput = root.querySelector('.whovix-qty input');
    var minus = root.querySelector('[data-whovix-qty-minus]');
    var plus = root.querySelector('[data-whovix-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1, 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value || 1, 10) + 1;
    });

    // Buy Now
    var buyBtn = document.getElementById('WhovixBuyNow-' + sectionId);
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var form = document.getElementById('WhovixProductForm-' + sectionId);
        var formData = new FormData(form);
        buyBtn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyBtn.removeAttribute('disabled'); });
      });
    }

    // Size guide modal
    var openBtns = root.querySelectorAll('[data-whovix-open-sizeguide]');
    var modal = document.getElementById('WhovixSizeGuideModal');
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (modal) modal.setAttribute('data-open', 'true');
      });
    });
  }

  return { init: init };
})();